<template>
  <div class="home noselect">

    <div class="backdrop backdrop-hatosan">
      <div class="pattern">

      </div>
    </div>

    <div class="backdrop backdrop-tutorial">
      <div class="pattern">

      </div>
    </div>

    <div class="backdrop backdrop-checkerboard">
      <div class="pattern">

      </div>
    </div>

    <div class="logo">
      <img class="logo-image" src="/images/hato-store-logo-white.svg" alt="">
    </div>

    <div class="logo-hatospecial">
      <img class="logo-hatodrop" src="/images/hatodrop.png">
      <img class="logo-special" src="/images/christmasspecial.png">
    </div>

    <div class="toggle-about"
    @click="showAbout = !showAbout"
    v-show="!gameHappening"
    :class="{
      'about-active': showAbout
      }"
    >
      <div v-if="!showAbout">i</div>
      <div v-if="showAbout">&times;</div>
    </div>

    <div class="about item" v-show="showAbout && !gameHappening">
      <div class="main">

        <div class="">
          <h3>鳩落とし HATO DROP</h3>
          <p>We are celebrating the holiday season with a new game! Play Hato Drop now to win a range of discounts for a limited time at <a href="https://hato.store" target="
            ">Hato Store</a>.</p>
        </div>
        <div class="">
          <h3>How to win</h3>
          <p>Knock all the coloured blocks down without letting Hato san fall to win the top prize!
            <a class="watch-tutorial" @click="enterTutorial">
              Watch tutorial
            </a>
          </p>
        </div>

        <div class="" v-if="false">
          <!-- To see how the experts play<br> -->
          <!-- See how the <a href="https://youtu.be/00wbmc3U2Vg?t=59" target="_blank">experts play</a> -->
          See how the experts play
          <br>
          <iframe width="448" height="252" src="https://www.youtube.com/embed/00wbmc3U2Vg?start=59" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>

      </div>
    </div>

    <div class="graphics">

      <img class="welcome item" src="/images/welcome.png">

      <div class="hatospecial item">
        <img class="hatodrop" src="/images/hatodrop.png">
        <img class="special" src="/images/christmasspecial.png">
      </div>

      <img class="super-tutorial item" src="/images/tutorial.png">
      <img class="super-go item" src="/images/go.png">

      <div class="intro item">
        <div class="main">
          <!-- Welcome to our new mini game! For the month of December we’re giving away prizes and discounts  all you have to do is have a go to win. -->
          <!-- Welcome to Hato Drop, play to win discounts off of your wares from the store. From 5-25% off have a go to&nbsp;win&nbsp;now. -->
          Welcome to Hato Drop. Play to win up to 25% off of your wares from the store.
        </div>
        <a class="play" @click="enterTutorial">
          Let's Go!
          <!-- How to play -->
        </a>
        <div class="sub">
          *Note: Prizes are redeemable at the checkout. Not valid without purchase.
        </div>
      </div>

      <div class="tutorial item">
        <div class="main">
          <!-- swipe across to increase your prize. Careful not to let hato san fall down. -->
          <!-- Hit all blocks apart from the red one to win the full prize! You must not to let Hato San fall down! -->
          <!-- Knock the blocks off without dropping Hato San to win! The more you knock off the bigger the prize! -->
          Knock all the coloured blocks down without letting Darumasan fall to win the top prize!
        </div>
      </div>

      <a class="start" @click="enterGame">
        Start
      </a>

      <a class="retry" @click="enterGame">
        Retry
      </a>

      <div class="progress">
        <div class="bar">

        </div>
      </div>

      <div class="ticker ticker-special">
      </div>

      <div class="results item">
        <div class="graphic">
          <img v-if="gamePrize>0" class="win" src="/images/win.png">
          <img v-else class="lost" src="/images/lost2.png">
        </div>
        <div class="info">
          <div class="">
            <div class="main" v-if="gamePrize>=1">
              <!-- Nice! You have won: <span>{{discountLabel}}</span> -->
              Nice! You have won a discount!
            </div>
            <div class="main" v-else>
              Almost there...
              <!-- Good try. Here's <span>{{discountLabel}}</span> -->
            </div>
          </div>
          <div class="">
            <a class="buy" @click="openShopLink" v-if="gamePrize>=1">
              <!-- Shop now to claim your prize -->
              Shop now to claim <span>{{discountLabel}}</span>
            </a>
            <a class="buy" @click="enterGame" v-else>
              Try again
            </a>
          </div>
        </div>
        <div class="">
        </div>

      </div>

    </div>

    <div class="subtitle" v-if="subtitle">
      {{subtitle}}
    </div>

    <div class="loading" v-if="loading">
      <!-- <img class="loading-logo" src="/images/hato-store-logo-white.svg" alt=""> -->
      <div class="loading-background">

      </div>
    </div>

    <Otoshi
    id="otoshi"
    ref="otoshi"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Otoshi from '@/components/Otoshi.vue'
import gsap from 'gsap'
import _ from 'lodash'

const autoPlay = window && window.location.hash == '#fast' ? true : false
const speed = autoPlay ? 5 : 1;
const gameSpeed = autoPlay ? 3 : 1;
const bounceDur = 1

export default {
  name: 'Home',

  data () {
    return {
      subtitle: '',
      showAbout: false,
      loading: true,
      discountLabel: '5% Off',
      discountLink: 'https://hato.store/discount/GOODTRY?discount_name=GOODTRY',
      gameHappening: false,
      gamePrize: 0,
      enableRepeatCheckGameState: false
    }
  },

  components: {
    Otoshi
  },

  mounted () {
    this.settings()
    this.timeline ()
  },

  methods: {
    gameTriggerStart () {
      this.$refs.otoshi.enableUserInteraction()
    },
    gameTriggerPause () {
      this.$refs.otoshi.disableUserInteraction()
    },
    gameTriggerReset () {
      this.gamePrize = 0
      this.$refs.otoshi.resetObjects()
    },
    gameGetResults () {
      return this.$refs.otoshi.getGameState()
    },
    gameTriggerTutorialLight () {
      this.$refs.otoshi.changeLightMode(1)
    },
    gameTriggerDefaultLight () {
      this.$refs.otoshi.changeLightMode(0)
    },
    openShopLink () {
      if (window) {
        let link = this.discountLink
        window.open(link, '_parent');
      }
    },
    setupComplete () {
      this.loading = false
    },
    setSubtitle (text) {
      this.subtitle = text || ''
    },
    settings () {
      this.gameTriggerPause()
      this.gameTriggerReset()
      this.gameTriggerDefaultLight()
    },
    timeline () {
      let wel = '.welcome'
      let hs = '.hatospecial'
      let hat = '.hatodrop'
      let spe = '.special'
      let intro = '.intro'
      let start = '.start'
      let startRetry = '.retry'
      let tutorial = '.tutorial'
      let results = '.results'
      let progress = '.progress'
      let logo = '.logo'
      let logoSpecial = '.logo-hatospecial'
      let supertutorial = '.super-tutorial'
      let supergo = '.super-go'
      let toggleAbout = '.toggle-about'

      let backdrophatosan = '.backdrop-hatosan'
      let backdroptutorial = '.backdrop-tutorial'
      let backdropcheckerboard = '.backdrop-checkerboard'

      let tl = gsap.timeline()

      tl.addLabel('reset')

      tl.to([start, startRetry, progress, logo, logoSpecial, toggleAbout, backdrophatosan, backdroptutorial, backdropcheckerboard], {
        autoAlpha: 0,
      })
      tl.to([wel, hs, intro, tutorial, results, supertutorial, supergo], {
        autoAlpha: 0,
        left: '50%',
        x: '-50%',
        duration: 0
      })

      tl.addLabel('welcome-start')
      // tl.delay(2)

      tl.set(backdrophatosan, {autoAlpha: 1})

      tl.fromTo(wel, {
        top: '0%'
      }, {
        top: '50%',
        y: '-50%',
        autoAlpha: 1,
        delay: 1,
        duration: bounceDur,
        ease: "bounce.out",
        // onStart: ()=> {
        //   this.setupComplete()
        //   this.setSubtitle('Welcome!')
        // },
      })

      tl.add(()=> {
        this.setupComplete()
      },'<')
      tl.add(()=> {
        this.setSubtitle('Welcome!')
      },'<0.5')


      tl.addLabel('welcome-end')
      tl.addLabel('title-start')

      tl.fromTo(hs, {
        top: '0%'
      }, {
        top: '50%',
        y: '-50%',
        autoAlpha: 1,
        delay: 2,
        duration: bounceDur,
        ease: "bounce.out",
        // onStart: () => {
        //   this.setSubtitle('HATO DROP CHRISTMAS SPECIAL!')
        // }
      })

      tl.add(()=> {
        this.setSubtitle()
      },'<0')
      tl.add(()=> {
        this.setSubtitle('HATO DROP CHRISTMAS SPECIAL!')
      },'<0.3')

      tl.fromTo(wel, {
        top: '50%'
      }, {
        top: '150%',
        // rotateX: '10%',
        autoAlpha: 0,
        delay: -bounceDur,
        duration: bounceDur,
        ease: "bounce.out"
      })

      tl.addLabel('title-end')
      tl.addLabel('intro-start')


      tl.to([logo, logoSpecial, toggleAbout], {
        autoAlpha: 1,
        duration: 0.2,
        delay: 2,
      })

      // tl.fromTo(intro, {
      //   top: '0%'
      // }, {
      //   top: '50%',
      //   y: '-50%',
      //   autoAlpha: 1,
      //   delay: 0,
      //   duration: bounceDur,
      //   ease: "bounce.out",
      //   // onStart: () => {
      //   //   this.setSubtitle()
      //   // }
      // })

      tl.add(()=> {
        this.setSubtitle()
      },'<')

      tl.fromTo(hs, {
        top: '50%'
      }, {
        top: '150%',
        // rotateX: '10%',
        autoAlpha: 0,
        delay: -bounceDur,
        duration: bounceDur,
        ease: "bounce.out"
      })

      tl.fromTo(intro, {
        top: '50%',
        y: '-50%',
      }, {
        top: '50%',
        y: '-50%',
        autoAlpha: 1,
        delay: 1,
        duration: bounceDur * 0.5,
        // ease: "bounce.out",
        // onStart: () => {
        //   this.setSubtitle()
        // }
      })

      tl.addLabel('intro-end')

      tl.addLabel('step4')

      tl.timeScale( speed );




      // tl.add(() => {
      //   this.setSubtitle('welcome!')
      // }, 'welcome-start')
      //
      // tl.add(() => {
      //   this.setSubtitle(false)
      // }, 'welcome-end')
      //
      // tl.add(() => {
      //   this.setSubtitle('HATO DROP CHRISTMAS SPECIAL')
      // }, 'title-start')
      //
      // tl.add(() => {
      //   this.setSubtitle(false)
      // }, 'title-end')

      tl.play()

      if (autoPlay) {
        tl.add(() => {
          // this.enterTutorial()
        }, ">1")
      }
      // tl.pause()
      // tl.seek()
    },
    enterTutorial () {

      this.gameTriggerStart()
      this.enableAutoCheckGameState()

      let tl = gsap.timeline()
      let intro = '.intro'
      let start = '.start:not(.retry)'
      let startRetry = '.retry'
      let tutorial = '.tutorial'
      let backdrophatosan = '.backdrop-hatosan'
      let backdroptutorial = '.backdrop-tutorial'
      let backdropcheckerboard = '.backdrop-checkerboard'
      let otoshi = '#otoshi'

      tl.fromTo(intro, {
        top: '50%'
      }, {
        top: '150%',
        // rotateX: '10%',
        autoAlpha: 0,
        duration: bounceDur,
        ease: "bounce.out"
      })

      tl.set(backdrophatosan, {autoAlpha: 0})
      tl.set(backdropcheckerboard, {autoAlpha: 0})
      tl.set(backdroptutorial, {autoAlpha: 1})
      tl.set(otoshi, {background: '#111'})

      tl.fromTo(otoshi, {
        scale: 1
      }, {
        scale: 0.8,
        duration: 0.2,
        ease: 'power2.inOut'
      })
      // tl.fromTo(tutorial, {
      //   bottom: '0',
      //   y: '-50%',
      // }, {
      //   bottom: '0',
      //   y: '0%',
      //   autoAlpha: 1,
      //   // delay: -bounceDur,
      //   duration: bounceDur,
      //   ease: "bounce.out"
      // })

      tl.add(()=> {
        this.setSubtitle()
        this.gameTriggerTutorialLight()
      },'<0')
      tl.add(()=> {
        this.setSubtitle('Tutorial')
      },'>0.5')

      tl.set(tutorial, {
        bottom: '0',
        y: '0%',
        autoAlpha: 1,
        delay: 2,
      })

      tl.add(()=> {
        this.setSubtitle()
      },'<-0.3')

      tl.fromTo(start, {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        delay: 3,
        duration: bounceDur,
      })

      tl.set(startRetry, {
        autoAlpha: 0,
      })
      // tl.fromTo(startRetry, {
      //   autoAlpha: 1,
      // }, {
      //   autoAlpha: 0,
      //   duration: .5
      // })

      tl.timeScale( speed );

    },
    enterGame () {

      let showGo = !this.gameHappening

      this.gameTriggerDefaultLight()
      this.disableAutoCheckGameState()
      this.gameTriggerReset()
      this.gameTriggerStart()
      this.debounceGameEnd()

      let tl = gsap.timeline()
      let intro = '.intro'
      let start = '.start'
      let startRetry = '.retry'
      let progress = '.progress'
      let tutorial = '.tutorial'
      let bar = '.bar'
      let results = '.results'
      let supertutorial = '.super-tutorial'
      let supergo = '.super-go'
      let otoshi = '#otoshi'

      let backdrophatosan = '.backdrop-hatosan'
      let backdroptutorial = '.backdrop-tutorial'
      let backdropcheckerboard = '.backdrop-checkerboard'

      // console.log('this.debounceGameEnd called from bar tl')

      gsap.killTweensOf(bar)

      tl.set(progress, {
        autoAlpha: 0,
      })
      tl.set(startRetry, {
        autoAlpha: 0,
      })
      tl.set(bar, {
        width: '100%',
        background: '#2dff3b',
      })
      tl.set(results, {
        top: '0%',
        autoAlpha: 0
      })

      tl.set(backdrophatosan, {autoAlpha: 0})
      tl.set(backdropcheckerboard, {autoAlpha: 1})
      tl.set(backdroptutorial, {autoAlpha: 0})

      tl.to(otoshi, {
        scale: 1,
        duration: 0.2,
        background: 'transparent',
      })


      tl.to(tutorial, {
        autoAlpha: 0,
        duration: .1,
      })

      tl.to(start, {
        autoAlpha: 0,
        duration: .1,
        delay: -0.1
      })

      if (showGo) {

        tl.fromTo(supergo, {
          top: '0%',
          y: '0%',
        }, {
          top: '50%',
          y: '-50%',
          autoAlpha: 1,
          delay: 1,
          duration: bounceDur * 0.5,
          ease: "bounce.out"
        })

        tl.add(()=> {
          this.setSubtitle('You got 10 seconds... Go!')
        },'<0')

        tl.fromTo(supergo, {
          top: '50%',
        }, {
          top: '250%',
          autoAlpha: 0,
          duration: bounceDur * 0.5,
          ease: "bounce.out",
          delay: 2
        })

      }

      tl.add(()=> {
        this.setSubtitle()
        this.gameHappening=true
      },'>-0.5')

      tl.to(progress, {
        autoAlpha: 1,
        duration: .1,
      })

      tl.fromTo(bar, {
        width: '100%',
        background: '#2dff3b',
      }, {
        width: '0%',
        background: '#ffb48f',
        duration: (10/gameSpeed),
        ease: 'none',
        delay: 0,
        // onStart: () => {
        //   this.debounceGameEnd()
        //   console.log('this.debounceGameEnd called from bar tl')
        // }
        // onComplete: () => {
        //   // this.gameEnded()
        //   this.gameEnded()
        // }
      })

      tl.add(() => {
        this.debounceShowRetryAfterGameStarted()
        this.debounceHideRetryAfterGameStarted()
        this.debounceGameEnd()
      }, '<')

      // tl.to(startRetry, {
      //   autoAlpha: 1,
      //   duration: .2,
      //   delay: (-10/gameSpeed)+1
      // })

    },
    debounceShowRetryAfterGameStarted: _.debounce(function () {
      let startRetry = '.retry'
      gsap.killTweensOf(startRetry)
      gsap.to(startRetry, {
        autoAlpha: 1,
        duration: .2,
      })
    }, 3000/gameSpeed),
    debounceHideRetryAfterGameStarted: _.debounce(function () {
      let startRetry = '.retry'
      gsap.killTweensOf(startRetry)
      gsap.to(startRetry, {
        autoAlpha: 0,
        duration: .2,
      })
    }, 9000/gameSpeed),
    debounceShowRetryAfterResultsAnnounced: _.debounce(function () {
      let startRetry = '.retry'
      gsap.killTweensOf(startRetry)
      gsap.to(startRetry, {
        autoAlpha: 1,
        duration: .2,
      })
    }, 5000/gameSpeed),
    debounceGameEnd: _.debounce(function () {

      console.log('this.debounceGameEnd executing!!!!!!')

      this.gameTriggerPause()
      this.debounceShowRetryAfterResultsAnnounced()

      this.gameHappening = false
      this.gamePrize = 0

      // check logic

      // discountLabel: '10% Off',
      // discountLink: 'https://hato.store/discount/GOODTRY',
      this.checkGameLevel ()

      let tl = gsap.timeline()
      let results = '.results'
      let resultsGraphic = '.results .graphic'
      let resultsInfo = '.results .info'

      tl.set([resultsGraphic,resultsInfo], {
        autoAlpha: 0
      })

      tl.set(results, {
        top: '50%',
        y: '-50%',
        autoAlpha: 1,
        delay: 0.5
      })
      tl.fromTo(resultsGraphic, {
        y: '-30%'
      }, {
        y: '30%',
        autoAlpha: 1,
        duration: .5,
        ease: "bounce.out"
      })
      tl.to(resultsGraphic, {
        y: '0%',
        duration: .5,
        ease: "back.out",
        delay: 2
      })
      tl.fromTo(resultsInfo, {
        y: '30%'
      }, {
        y: '0%',
        autoAlpha: 1,
        duration: .5,
        ease: "bounce.out",
        delay: '-=2.5'
      })

    }, 10000/gameSpeed),
    debounceRepeatCheckGameState: _.debounce(function () {
      if (this.enableRepeatCheckGameState) {
        this.enableAutoDetectAndReset()
        this.debounceRepeatCheckGameState()
      }
    }, 500),
    enableAutoCheckGameState () {
      this.enableRepeatCheckGameState = true
      this.debounceRepeatCheckGameState()
    },
    disableAutoCheckGameState () {
      this.enableRepeatCheckGameState = false
      // this.debounceRepeatCheckGameState.cancel()
    },
    enableAutoDetectAndReset () {
      let results = this.gameGetResults()
      // console.log('results:', results)
      if (results.posy < -10 || (Math.abs(results.rotz)) > 0.5 || (Math.abs(results.rotx)) > 0.5) {
        console.log('reset...', results.rotz, results.rotx)
        this.debounceGameTriggerReset()
      }
    },
    debounceGameTriggerReset: _.debounce(function () {
      console.log('debounceGameTriggerReset reset...')
      if (this.enableRepeatCheckGameState) {
        this.gameTriggerReset()
      }
    }, {trailing: true}, 1000),
    checkGameLevel () {
      let level = 0

      let results = this.gameGetResults()

      // console.log('results:', results)
      let positions = [
        {y:2},
        {y:4},
        {y:6},
        {y:8},
        {y:10},
        {y:13},
      ]

      if (results.posy > positions[5].y-0.5) {
        level = 0
      } else
      if (results.posy > positions[4].y-0.5) {
        level = 1
      } else
      if (results.posy > positions[3].y-0.5) {
        level = 2
      } else
      if (results.posy > positions[2].y-0.5) {
        level = 3
      } else
      if (results.posy > positions[1].y-0.5) {
        level = 4
      } else
      if (results.posy > positions[0].y-0.5) {
        level = 5
      }

      //rot y = horizontal
      console.log(`level: ${level}`, `posy: ${results.posy}`, `rotz: ${results.rotz}`)

      if (results.posy < 0 || (Math.abs(results.rotz)) > 0.2 || (Math.abs(results.rotx)) > 0.2) {
        level = 0
      }

      switch (level) {
        case 2:
          this.discountLabel = '10% Off'
          this.discountLink = 'https://hato.store/discount/NOTBADATALL?discount_name=NOTBADATALL'
          break;
        case 3:
          this.discountLabel = '15% Off'
          this.discountLink = 'https://hato.store/discount/OOHPRETTYGOOD?discount_name=OOHPRETTYGOOD'
          break;
        case 4:
          this.discountLabel = '20% Off'
          this.discountLink = 'https://hato.store/discount/WOAHNICE?discount_name=WOAHNICE'
          break;
        case 5:
          this.discountLabel = '25% Off'
          this.discountLink = 'https://hato.store/discount/YOUNAILEDIT?discount_name=YOUNAILEDIT'
          break;
        case 1:
          this.discountLabel = '5% Off'
          this.discountLink = 'https://hato.store/discount/GOODTRY?discount_name=GOODTRY'
          break;
        case 0:
        default:
          this.discountLabel = ''
          this.discountLink = ''
          break;
      }


      this.gamePrize = level
    }
  }
}
</script>

<style media="screen" lang="scss">
$pink: #ffb48f;
$green: #2dff3b;

.home {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .backdrop {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .pattern {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      animation-name: tick;
      animation-duration: 60s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      @media (max-width: 768px) {
        animation-duration: 10s;
      }
    }

    &.backdrop-hatosan {

      background-color: #111111;

      .pattern {
        background-image: url('/images/face-white-repeat-2.png');
        background-size: 200px auto;
        opacity: 0.05;
      }
    }

    &.backdrop-tutorial {

      background-color: #f5c3d1;

      .pattern {
        background-image: url('/images/tutorial-pattern-pink.png');
        background-size: 200px auto;
        opacity: 0.5;
      }
    }

    &.backdrop-checkerboard {

      background-color: #000;

      .pattern {
        animation-name: tickDown;
        animation-duration: 1s;
        background: repeating-conic-gradient(rgba(255,0,0,0.8) 0% 25%, rgba(0,0,255,0.8) 0% 50%)
  50%/ 200px 200px;
        opacity: 0.1;
      }
    }
  }
  @keyframes tick {
    from {background-position: 0 0;}
    to {background-position: 200px 0;}
  }
  @keyframes tickDown {
    from {background-position: 0 0;}
    to {background-position: 0 200px;}
  }

}

.logo {
  position: absolute;
  z-index: 999;
  left: 0;
  bottom: 0;
  margin: 1.5rem;
  width: 15vw;
  // margin-left: 3.5rem;
  margin-bottom: 1.15rem;

  img {
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    left: 0;
    bottom: 0;
    // right: 0;
    margin: 1.25rem 1.2rem;
    // margin-top: 1.2rem;
    width: 50vw;
    img {
      // opacity: 0.1;
    }
  }
}

.logo-hatospecial {
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  img.logo-hatodrop {
    position: absolute;
    left: 0;
    margin: 1rem;
    width: 25vw;
    @media (max-width: 768px) {
      width: 35vw;
    }
  }
  img.logo-special {
    position: absolute;
    right: 0rem;
    margin: 1rem;
    width: 30vw;
    @media (max-width: 768px) {
      width: 50vw;
    }
  }
  @media (max-width: 768px) {
    // width: 40vw;
  }
}

.ticker {
  opacity: 0;
  position: absolute;
  z-index: 99;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4rem;
  background-image: url('/images/christmasspecial.png');
  background-repeat: repeat-x;
  background-size: auto 90%;
  background-position: 0% center;
  animation-name: tick;
  animation-duration: 30s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes tick {
  from {background-position: 0% center;}
  to {background-position: 100% center;}
}

img {
  display: block;
  pointer-events: none;
  max-width: 100%;
}

a {
  line-height: 1.5;
  padding-top: .2em;
  text-decoration: none;
}

.loading {
  position: absolute;
  z-index: 99999999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  .loading-background {
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/images/hato-store-logo-white.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 200px;
  }
}

.subtitle {
  position: absolute;
  z-index: 99999;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  margin: 2rem auto;
  padding: .75em 1em .5em;
  font-size: 1.5vw;
  display: inline-block;
  background: $green;
  text-transform: uppercase;
  color: black;
  @media (max-width: 768px) {
    font-size: 4vw;
  }
}

.toggle-about {
  cursor: pointer;
  position: absolute;
  z-index: 99999;
  // top: 0;
  // right: 0;
  margin: 1.2rem 1.5rem;

  bottom: 0;
  right: 0;
  margin-left: 18vw;
  // display: none;

  &.about-active {
    z-index: 999999999;
  }

  div {
    opacity: 0.5;
    color: black;
    height: 2rem;
    width: 2rem;
    font-size: 1.4rem;
    text-align: center;
    line-height: 2.3rem;
    border: 1px solid white;
    background: white;
    border-radius: 50%;
  }
}

.about {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;

  color: white;
  padding: 0;
  background: rgba(0,0,0,0.8);
  width: 100%;
  height: 100%;
  z-index: 99999999;

  .main {
    position: absolute;
    z-index: 9999;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);

    width: 70vw;
    text-align: center;
    padding: 3rem;
    // backdrop-filter: blur(50px);
    background: black;
    // background: $pink;



    border-radius: 2rem;
    border: 2px solid white;
    max-width: 100%;
    h3 {
      font-size: 2.25vw;
      line-height: 1.5;
      margin-top: .75em;
      margin-bottom: .15em;
      // color: yellow;
    }
    p {
      color: rgba(255,255,255,0.7);
      font-size: 2.25vw;
      line-height: 1.5;
      margin-bottom: 1em;
      margin-top: 0;
      // color: pink;
    }
    .watch-tutorial {
      color: black;
      display: block;
      text-decoration: none;
      background: green;
      border-radius: 99px;
      width: 9em;
      font-size: 2.25vw;
      margin: auto;
      margin-top: 1em;
      pointer-events: auto;
      cursor: pointer;
      background: $green;
      color: black;
    }

  }
  a {
    color: inherit;
    text-decoration: underline;
  }
  @media (max-width: 768px) {
    .main {
      padding: 2em 1em 1em;
      width: 95%;
      line-height: 1.7;
      iframe {
        width: 100%;
      }
      h3 {
        margin-top: 2em;
        font-size: 6vw;
        margin-bottom: .5em;
        &:first-child {
          margin-top: .5em;
        }
      }
      p {
        // opacity: 0.5;
        margin-top: 0;
        font-size: 5vw;
        color: rgba(255,255,255,0.7);
      }
      .watch-tutorial {
        margin-top: 1em;
        font-size: 5vw;
      }
    }
  }
}

.graphics {
  position: absolute;
  // z-index: 9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;


  .item {
    margin: auto;
    position: absolute;
    z-index: 599;
  }

  .welcome {
    // left: 50%;
    // top: 50%;
    width: 50vw;

    @media (max-width: 768px) {
      width: 90vw;
    }
    // transform: translate3d(-50%, -50%, 0);
  }

  .hatospecial {
    // left: 50%;
    // top: 50%;
    width: 65vw;
    @media (max-width: 768px) {
      width: 90vw;
    }
    // transform: translate3d(-50%, -50%, 0);
  }

  .super-go {
    width: 65vw;
    @media (max-width: 768px) {
      width: 90vw;
    }
  }

  .super-tutorial {
    width: 65vw;
    @media (max-width: 768px) {
      width: 90vw;
    }
  }

  .hatodrop {
    // left: 50%;
    // top: 50%;
    // width: 50vw;
    // transform: translate3d(-50%, -50%, 0);
  }

  .special {
    // left: 50%;
    // top: 50%;
    // width: 50vw;
    // transform: translate3d(-50%, -50%, 0);
  }

  .intro {
    // left: 50%;
    // top: 50%;
    color: white;
    // transform: translate3d(-50%, -50%, 0);
    font-size: 2.25vw;
    line-height: 1.5;
    width: 24em;
    text-align: center;
    padding: 3rem;
    // backdrop-filter: blur(50px);
    background: black;
    border-radius: 2rem;
    border: 2px solid white;
    // box-shadow: 0px 0 1em 0 rgba(255,200,0,1);

    .main {
      margin-bottom: 5%;
    }
    .sub {
      margin-top: 5%;
      font-size: 50%;
      // max-width: 10em;
    }
    .play {
      display: block;
      background: green;
      border-radius: 99px;
      margin-top: 2em;
      width: 6em;
      font-size: 150%;
      margin: auto;
      pointer-events: auto;
      cursor: pointer;
      background: $green;
      color: black;
      // box-shadow: -5px -5px 15px rgba(0,0,0,0.7) inset;

      &:hover {
        // box-shadow: -5px -5px 15px rgba(0,0,0,0.5) inset;
        // background: $pink;
        // box-shadow: 0px 0px 1em $green;
      }
    }

    @media (max-width: 768px) {
      padding: 2em 1em;
      font-size: 5.5vw;
      width: 95%;
      border-radius: 2rem;
      border: 2px solid white;
      line-height: 1.7;

      .sub {
        margin-top: 2em;
        font-size: 80%;
        // max-width: 10em;
      }
      .play {
        width: 100%;
      }
    }
  }

  .tutorial {
    // left: 50%;
    // top: 50%;
    z-index: 9999;
    color: white;
    // transform: translate3d(-50%, -50%, 0);
    font-size: 1.75vw;
    line-height: 1.5;
    width: 33em;
    text-align: center;
    padding: 1rem 2rem;
    // backdrop-filter: blur(50px);
    background: black;
    // border-radius: 2rem;

    margin: 2rem auto;
    padding: .75em 1em .5em;
    font-size: 1.5vw;
    margin-bottom: 1rem;

    background: $green;
    color: black;
    text-transform: uppercase;
    // border: 2px solid white;
    // box-shadow: 0px 0 1em 0 rgba(255,200,0,1);

    .main {
    }

    @media (max-width: 768px) {
      padding: 1em 1em;
      font-size: 4vw;
      width: 90%;
      // border-radius: 2rem;
      // border: 2px solid white;
      line-height: 1.7;
      .sub {
        margin-top: 3em;
        font-size: 80%;
        // max-width: 10em;
      }
    }
  }

  .start {
    position: fixed;
    z-index: 9999;

    right: 2rem;
    top: 50%;
    transform: translateY(-50%);

    display: block;
    background: green;
    border-radius: 99px;
    margin-top: 2em;

    width: 6em;
    height: 6em;
    line-height: 5.75em;
    background: transparent;
    text-transform: uppercase;

    font-size: 150%;
    margin: auto;
    pointer-events: auto;
    cursor: pointer;
    background: $green;
    color: black;

    background: transparent;
    color: #fff;
    border: 2px solid #fff;
    background: transparent;
    color: $green;
    border: 2px solid $green;

    &:hover {
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
    }




    @media (max-width: 768px) {
      font-size: 120%;
      width: 5em;
      height: 5em;
      line-height: 4.75em;
      background: transparent;
      text-transform: uppercase;
      right: 1rem;
      background: transparent;
      color: $green;
      border: 2px solid $green;
      &:hover {
        background: transparent;
        color: #fff;
        border: 2px solid #fff;
      }
    }
  }

  .retry {

    position: fixed;
    z-index: 9999;

    right: 2rem;
    top: 50%;
    transform: translateY(-50%);

    display: block;
    background: green;
    border-radius: 99px;
    margin-top: 2em;

    width: 6em;
    height: 6em;
    line-height: 5.75em;
    background: transparent;
    text-transform: uppercase;

    font-size: 150%;
    margin: auto;
    pointer-events: auto;
    cursor: pointer;
    background: $green;
    color: black;

    &:hover {
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
    }
    @media (max-width: 768px) {
      font-size: 120%;
      width: 5em;
      height: 5em;
      line-height: 4.75em;
      background: transparent;
      text-transform: uppercase;




      background: transparent;
      color: $green;
      border: 2px solid $green;
      &:hover {
        background: transparent;
        color: #fff;
        border: 2px solid #fff;
      }
    }

    top: unset;
    right: 2rem;
    top: 6rem;
    transform: none;
    margin: 0;

    background: $green;
    color: black;

    background: transparent;
    color: white;
    border: 2px solid white;

    &:hover {
      color: $green;
      border: 2px solid $green;
    }

    @media (max-width: 768px) {

      bottom: 4rem;
      font-size: 90%;

      right: unset;
      bottom: unset;
      top: 3.5rem;
      right: 1rem;
      // background: transparent;
      // color: $green;
      // border: 2px solid $green;
      // &:hover {
      //   background: transparent;
      //   color: #fff;
      //   border: 2px solid #fff;
      // }
    }
  }


  .progress {
    // background: $green;
    position: fixed;
    z-index: 9;
    height: 4rem;
    // border-radius: 2rem;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;

    @media (max-width: 768px) {
      height: 4rem;
    }

    .bar {
      // border-radius: 2rem;
      width: 100%;
      height: 100%;
    }
  }


  .results {
    // left: 50%;
    // top: 50%;
    color: white;
    // transform: translate3d(-50%, -50%, 0);
    font-size: 2.25vw;
    line-height: 1.5;
    // width: 30rem;
    text-align: center;
    padding: 3rem;
    // backdrop-filter: blur(50px);
    // background: black;
    // border-radius: 2rem;
    // border: 2px solid white;
    // box-shadow: 0px 0 1em 0 rgba(255,200,0,1);

    .win, .lost, img {
      max-width: 50vw;
    }

    .info {
      display: inline-block;
      margin: 2rem auto;
      background: black;
      border-radius: 3rem;
      padding: 2rem 2rem;
      border: 2px solid white;
    }

    .main {
      // font-size: 1.75vw;
      margin-bottom: 5%;
      line-height: 1.5;
      text-align: center;
      display: inline-block;
    }

    .buy {
      display: inline-block;
      background: green;
      border-radius: 99px;
      margin-top: 2em;
      padding: 1rem 2rem;
      // width: 6em;
      font-size: 100%;
      margin: auto;
      pointer-events: auto;
      cursor: pointer;
      background: $green;
      color: black;

      // box-shadow: -5px -5px 15px rgba(0,0,0,0.7) inset;

      &:hover {
        // box-shadow: -5px -5px 15px rgba(0,0,0,0.5) inset;
      }
      // &:hover {
      //   background: $pink;
      // }
    }

    @media (max-width: 768px) {
      .win, .lost, img {
        max-width: 100%;
      }
      padding: 2em 0em;
      font-size: 5.5vw;
      width: 95%;
      border-radius: 1rem;
      // border: 2px solid white;
      line-height: 1.7;

      .info {
        display: inline-block;
        margin: 2rem auto;
        background: black;
        border-radius: 2rem;
        padding: 2rem 2rem;
        border: 2px solid white;
      }
      .play {
        width: 100%;
      }
    }
  }
}
</style>
